import { Component, OnInit } from '@angular/core';
import { PharmacieService } from 'src/app/service/pharmacie.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public afficherMonCompteModal = false;
  logo_png: any = 'assets/images/logo_giphar.png';

  constructor(
    public pharmacieService: PharmacieService
    ) { }

  ngOnInit(): void {
  }

  logout() {
    this.pharmacieService.logout().subscribe();
  }

  setModalState(event) {
    this.afficherMonCompteModal = event;
  }

}
